import { HttpClient } from '@zeta-core';
import { WP_DOCUMENT_QA } from '../services-path';
import { IDocumentCreateSessionRequest, IDocumentCreateSessionResponse, IDocumentResponse, IDocumentShowFilesRequest } from './types';

export * from './types';

export const WPDocumentQA = () => {
  return {
    uploadFiles: (payload: FormData) => HttpClient.upload<IDocumentResponse>(`${WP_DOCUMENT_QA}/document/v2/upload-pdfs`, payload),
    showFiles: (payload: IDocumentShowFilesRequest) => HttpClient.post<IDocumentResponse>(`${WP_DOCUMENT_QA}/document/show-pdfs `, payload),
    queryFiles: (payload: FormData) => HttpClient.post<IDocumentResponse>(`${WP_DOCUMENT_QA}/document/query-pdfs`, payload),
    chatSession: (session_id: string) => HttpClient.get<IDocumentResponse>(`${WP_DOCUMENT_QA}/chat_sessions/${session_id}`),
    chatSessionsByClient: ({ client_id }: { client_id: string }) => HttpClient.get<IDocumentResponse>(`${WP_DOCUMENT_QA}/chat_sessions/client/${client_id}`),
    chatSessionsByAdvisor: ({ advisor_id }: { advisor_id: string }) =>
      HttpClient.get<IDocumentResponse>(`${WP_DOCUMENT_QA}/chat_sessions/advisor/${advisor_id}`),
    deleteSession: (session_id: string) => HttpClient.delete<IDocumentResponse>(`${WP_DOCUMENT_QA}/chat_sessions/${session_id}`),
    updateChatSessionName: ({ session_name, session_id }: { session_name: string; session_id: string }) =>
      HttpClient.patch(`${WP_DOCUMENT_QA}/chat_sessions/${session_id}`, { session_name }),
    createSession: (payload: IDocumentCreateSessionRequest) =>
      HttpClient.post<IDocumentCreateSessionResponse>(`${WP_DOCUMENT_QA}/chat_sessions/create_session`, payload),
    downloadFile: (payload: IDocumentShowFilesRequest) =>
      HttpClient.download<IDocumentCreateSessionResponse>(`${WP_DOCUMENT_QA}/document/download-pdf`, payload),
  };
};
